import { render, staticRenderFns } from "./Toll.vue?vue&type=template&id=cb38167c&scoped=true&lang=pug&"
import script from "./Toll.vue?vue&type=script&lang=ts&"
export * from "./Toll.vue?vue&type=script&lang=ts&"
import style0 from "./Toll.vue?vue&type=style&index=0&id=cb38167c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb38167c",
  null
  
)

export default component.exports